import { links } from "./navMenu.data";

import { isTerminal, CLAIMS } from "../../../../constants";

import { isLeaderThunkAction } from "../../../../redux/actions/Auth/Thunk/isLeader.thunk.action";

import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

isTerminal ? import("./NavMenuTerminal.css") : import("./NavMenu.css");

const NavMenu = () => {

    const dispatch = useDispatch();
    const claims = useSelector(state => state.user?.claims);


    useEffect(() => {
        dispatch(isLeaderThunkAction());
    }, []);


    return (
        <div className="main-menu-container">
            <div className="nav-menu__items">
                {links &&
                    links.map((el) => {
                        return (
                            <NavLink
                                key={el.id}
                                to={el.path}
                                onClick={
                                    (localStorage.getItem("agreement") > 0 &&
                                        localStorage.getItem("documentSignType") < 1 &&
                                        claims && claims.length > 0 &&
                                        claims.find((element)=> element === CLAIMS.HAS_DOCUMENTS) &&
                                        el.title !== "Документы") ||
                                    (claims && claims.length > 0 &&
                                        claims.find((element)=> element === CLAIMS.HAS_DOCUMENTS) &&
                                        el.title !== "Документы" &&
                                        ((e) => e.preventDefault()))
                                }
                                className={
                                    ({ isActive }) => isActive
                                        ? "nav-menu-item-active"
                                        : "nav-menu-item"
                                }
                            >
                                {el.title}
                                {!isTerminal && el.notification
                                    ? (claims && claims.length > 0 &&
                                        claims.find((element)=> element === CLAIMS.HAS_DOCUMENTS)
                                        ? (<span className="show-active-notification">
                                            {
                                                el.notification ||
                                                claims && claims.length > 0 &&
                                                claims.find((element)=> element === CLAIMS.HAS_DOCUMENTS)
                                                    ? "!"
                                                    : null
                                            }
                                        </span>)
                                        : null
                                    ) : null}
                            </NavLink>
                        );
                    })}
            </div>
            {/*<div>*/}
            {
                localStorage.getItem("isLeader") === "true" && !isTerminal
                    ? <NavLink
                        to={"/divisions"}
                        onClick={
                            (localStorage.getItem("agreement") > 0 &&
                                localStorage.getItem("documentSignType") < 1 &&
                                claims && claims.length > 0 &&
                                claims.find((element)=> element === CLAIMS.HAS_DOCUMENTS) ) ||
                            (claims && claims.length > 0 &&
                                claims.find((element)=> element === CLAIMS.HAS_DOCUMENTS)  &&
                                ((e) => e.preventDefault()))
                        }
                        style={{ right: "0" }}
                        className={({ isActive }) =>
                            isActive
                                ? "divisions-active"
                                : "divisions-inactive"
                        }>
                        Мое подразделение
                    </NavLink>
                    //         : null
                    // )
                    : null
            }
        </div>
    );
};

export default React.memo(NavMenu);
